// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function isEnabled(category, settings, listPageType, isForcingPLP) {
  var keep = function (__x) {
    return Belt_Option.keep(__x, function (param) {
      if (listPageType !== undefined && typeof listPageType === "number") {
        return listPageType >= 2;
      } else {
        return true;
      }
    });
  };
  var category$1 = keep(category);
  var index = keep(settings.indexNode);
  var canRenderCLPBar = settings.linksAsSidebar;
  var plpCheck1 = category$1 !== undefined ? Category$Showside.hasProducts(category$1) || Category$Showside.Link.isStoreCategoryLink(category$1) : false;
  var plpCheck2 = category$1 !== undefined ? !Category$Showside.hasSubCategories(category$1) || isForcingPLP : false;
  var plpCheck3 = category$1 !== undefined ? Category$Showside.ExternalConnection.isConnectedToStoreCategory(category$1) : false;
  var canRenderPLPBar = category$1 !== undefined ? settings.filtersEnabled && plpCheck1 && plpCheck2 && plpCheck3 : Belt_Option.mapWithDefault(Belt_Option.keep(index, function (param) {
    return settings.filtersEnabled;
  }), false, function (indexNode) {
    return Belt_Option.isSome(Category$Showside.ExternalConnection.getStoreCategoryConnection(indexNode));
  });
  return [canRenderCLPBar, canRenderPLPBar];
}
function useSidebarState(param) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var match$1 = ViewportContext$Showside.use(undefined);
  var isMobile = match$1.isMobile;
  var match$2 = RouterProvider$Showside.useRouter(undefined);
  var match$3 = React.useState(function () {
    var match = config.settings.sidebarDesktopDefault;
    var match$1 = config.settings.sidebarMobileDefault;
    if (match) {
      return !isMobile;
    } else if (match$1) {
      return isMobile;
    } else {
      return false;
    }
  });
  var setIsSidebarOpen = match$3[1];
  React.useEffect(function () {
    var match = config.settings.sidebarDesktopDefault;
    var match$1 = config.settings.sidebarMobileDefault;
    var exit = 0;
    if (match && !isMobile) {
      Curry._1(setIsSidebarOpen, function (param) {
        return true;
      });
    } else {
      exit = 1;
    }
    if (exit === 1) {
      if (match$1 && isMobile) {
        Curry._1(setIsSidebarOpen, function (param) {
          return true;
        });
      }
    }
  }, [config.settings.sidebarMobileDefault, config.settings.sidebarDesktopDefault, isMobile, match$2.route]);
  return [match$3[0], setIsSidebarOpen];
}
export { isEnabled, useSidebarState };
/* react Not a pure module */